import type { FC, ReactNode } from "react";
import { Flex, Spacing, Text } from "@huub-web/ui";

import {
  contentColumnStyle,
  descriptionStyle,
  imagePanelStyle,
  imageStyle,
  titleStyle,
  wrapperStyle,
} from "./NvmBanner.css";

type NvmBannerProps = {
  children?: ReactNode;
  /**
   * Banner title displayed in the left panel
   */
  title: string;
  /**
   * Banner description displayed below the title
   */
  description: string;
  /**
   * URL of the image to display in the right panel
   */
  imageSrc: string;
};

/**
 * Reusable two-column banner for NVM theme slot overrides.
 */
export const NvmBanner: FC<NvmBannerProps> = ({
  children,
  title,
  description,
  imageSrc,
}) => {
  return (
    <>
      <Spacing height="m" />
      <Flex direction="column" className={wrapperStyle}>
        <Flex direction="column" gap="m" className={contentColumnStyle}>
          <Text variant="displayM" bold className={titleStyle}>
            {title}
          </Text>
          <Text
            variant="bodyM"
            color="currentColor75"
            className={descriptionStyle}
          >
            {description}
          </Text>
          {children}
        </Flex>
        <div className={imagePanelStyle}>
          <img className={imageStyle} src={imageSrc} alt="" loading="eager" />
        </div>
      </Flex>
    </>
  );
};
